import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvanoRequiredIconComponent } from './avano-required-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AvanoRequiredIconComponent],
  exports: [AvanoRequiredIconComponent]
})
export class AvanoRequiredIconModule { }
